import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=0d23ccd0&scoped=true&"
import script from "./Historic.vue?vue&type=script&lang=ts&"
export * from "./Historic.vue?vue&type=script&lang=ts&"
import style0 from "./Historic.vue?vue&type=style&index=0&id=0d23ccd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23ccd0",
  null
  
)

export default component.exports